import React from 'react';

interface EstimatedSalaryProps {
  salary: string | number | null | undefined;
}

export const formatEstimatedSalary = (salary: EstimatedSalaryProps['salary']): string => {
  if (salary == null || String(salary).trim() === '') return 'Not specified';
  const numericSalary = Number(String(salary).replace(/,/g, ''));
  if (Number.isFinite(numericSalary)) {
    return `RM ${numericSalary.toLocaleString('en-MY', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })}`;
  }
  return String(salary).trim();
};

const EstimatedSalary: React.FC<EstimatedSalaryProps> = ({ salary }) => {
  const salaryText = formatEstimatedSalary(salary);
  return (
    <div className="inline-flex min-w-[130px] max-w-full flex-col rounded-xl border border-[#A1AAD9]/35 bg-[#FFF5D7] px-3 py-2" aria-label={`Estimated Salary: ${salaryText}`}>
      <span className="text-[10px] font-semibold uppercase tracking-[0.08em] text-[#5A46AA]">Estimated Salary</span>
      <span className={`text-sm font-medium ${salaryText === 'Not specified' ? 'text-[#636363]' : 'text-[#342F43]'}`}>{salaryText}</span>
    </div>
  );
};

export default EstimatedSalary;
